import { borderRadius, colors } from './themeTokens'

const STROKE_WIDTH = 2

// CSS `border-style: dashed` can't set the gap, so the outline is an SVG background. The stroke is centred on
// the rect edge, so the rect is inset by half the stroke and its radius reduced by the same amount; otherwise the
// outer half is clipped and the dashes cut through the element's rounded corners.
export const dashedBorderBackground = (radius: string = borderRadius.DEFAULT) => {
	const inset = STROKE_WIDTH / 2
	const rx = Math.max(parseFloat(radius) - inset, 0)
	const svg =
		`<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%'>` +
		`<rect x='${inset}' y='${inset}' rx='${rx}' ry='${rx}' fill='none' stroke='${colors.charcoal['300']}' ` +
		`stroke-width='${STROKE_WIDTH}' stroke-dasharray='6 8' style='width:calc(100% - ${STROKE_WIDTH}px);height:calc(100% - ${STROKE_WIDTH}px)'/>` +
		`</svg>`
	return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`
}
